import sdl from '@jds/react-generated-sdl/JDSMegaMenuBlock';
import type { JDSMegaMenuBlockProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, MegaMenuBlockProps } from '../logic';

const Component = (props: MegaMenuBlockProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSMegaMenuBlock',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const MegaMenuBlock = withLogic(Component) as React.FC<MegaMenuBlockProps> & {
  slotName?: string;
};

MegaMenuBlock.displayName = 'MegaMenuBlock';
MegaMenuBlock.slotName = 'jds_mega_menu_block';

export { MegaMenuBlock, type JDSMegaMenuBlockProps };
